import { createAsyncThunk } from '@reduxjs/toolkit';
import store from '../../../..';
import ApiaApi, {
  IApiaApiRequestConfig,
  makeApiaUrl,
} from '../../../../../api/apiaApi/apiaApi';
import { TApiaModalRefreshDataResponse } from '../../../../../components/apia/execution/fields/apiaFinder/types';
import { arrayOrArray } from '../../../../../utils/util';
import { buttonsActions } from '../../../../buttonsSlice';
import { TAsyncThunkState, TRowsStructure } from '../../../types';
import { parseRows } from '../../util/rowsParser';
import { TQueriesActionsChain } from '../../../queueController';

export type TRefreshData = {
  fieldId: string;
  url?: string;
  requestConfig?: IApiaApiRequestConfig<unknown>;
  pageNumber?: number;
  queryData?: Record<string, unknown>;
  forceRefreshFromSavedFilters?: boolean;
  queueKey?: TQueriesActionsChain;
};

type TRefreshDataResponse = TApiaModalRefreshDataResponse;

const updateData = createAsyncThunk<
  TRowsStructure,
  TRefreshData,
  TAsyncThunkState
>(
  'querySlice/updateData',
  async (
    {
      fieldId,
      requestConfig,
      url,
      pageNumber,
      queryData,
      forceRefreshFromSavedFilters,
      // queueKey = 'directUpdateData',
    },
    thunkApi,
  ) => {
    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: true,
          action: 'disableTable',
        },
      ]),
    );
    const state = thunkApi.getState().querySlice.queries[fieldId];

    const response = await ApiaApi.post<TRefreshDataResponse>(
      url ??
        makeApiaUrl({
          action: 'refresh',
          pageNumber,
          ajaxUrl: state.ajaxUrl,
          react: true,
          forceRefreshFromSavedFilters,
        }),
      requestConfig
        ? { ...requestConfig, ...(queryData ? { queryData } : null) }
        : {
            notificationsCategory: 'apiaFinder',
            queryData,
          },
    );

    const pageInfo = response?.data?.function?.messages?.result?.pageInfo;
    const row = response?.data?.function?.messages?.result?.table?.row;

    store.dispatch(
      buttonsActions.updateAction([
        {
          performing: false,
          action: 'disableTable',
        },
      ]),
    );

    return {
      pageInfo: pageInfo ?? undefined,
      rows: parseRows(fieldId, (row && arrayOrArray(row)) || []),
    };
  },
);

export default updateData;
